// api endpoints
const companies = "/companies/:companyId";
const clients = "/clients/:clientId";
const connections = "/connections/:connectionId";
const api = {
  clients: {
    config: `${clients}/config`,
    create: `${clients}/companies`,
    companyLimitReached: `${clients}/companyLimitReached`,
  },
  companies: {
    config: `${companies}/config`,
    integrations: {
      sourceTypes: `${companies}/integrations/sourceTypes`,
      platform: `${companies}/integrations/:platformKey`,
    },
    createConnection: `${companies}/connections`,
    createFileConnection: `${companies}/connections/files`,
    complete: `${companies}/complete`,
    redirectValidate: `${companies}/redirect/validate`,
    displayText: `${companies}/displayText`,
    uploadFile: `${companies}${connections}/files`,
    customRedirect: `${companies}/customRedirect`,
  },
  validateOtp: "/otp/validate/:otp",
  connections: {
    success: `${connections}/success`,
    error: `${connections}/error`,
  },
};

export default api;
